import React from 'react'
import compose from 'recompose/compose'
import withWidth, { isWidthDown } from '@material-ui/core/withWidth'
import { Grid, Avatar, Typography, withStyles } from '@material-ui/core'
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer'
import cn from 'classnames'
import BusinessIcon from '@material-ui/icons/Business'
import themeCreateInjectableStyles from 'Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import AccountPageAccountDetailsStyles from './AccountDetails.styles'
import Alert from 'Components/OrderDetailsHeader/parts/comps/Alert'
import HeaderWithIcon from '../comps/HeaderWithIcon'
import FieldValuePair from '../comps/FieldValuePair'
import HorizontalLine from 'Components/HorizontalLine/HorizontalLine'

interface Props {
  any?: any,
  width: any,
  classes: any,
  account: any,
}

const AccountPageAccountDetailsComponent = (props: Props) => {
  const {
    width,
    classes,
    account,
  } = props
  const isSmDown = isWidthDown(`sm`, width)
  return (
    <div className={classes.wrapper}>
      <HeaderWithIcon
        icon={<BusinessIcon />}
        text={`Account Details`}
      />
      <FieldValuePair
        fieldName={`Account Name`}
        valueText={account.AccountName}
      />
      { account.CustomerCode &&
        <FieldValuePair
          fieldName={`Account Number`}
          valueText={account.CustomerCode}
        />
      }
      <Alert
        content={
          <React.Fragment>
            <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText)} component='span'>
              { `The Account is where your projects and orders are billed to. It is sometimes referred to as the` }
            </Typography>
            <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText, classes.fontWeight500)} component='span'>
              { ` Bill-To ` }
            </Typography>
            <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText)} component='span'>
              { `or` }
            </Typography>
            <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText, classes.fontWeight500)} component='span'>
              { ` Location` }
            </Typography>
            <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText)} component='span'>
              { `.` }
            </Typography>
          </React.Fragment>
        }
      />
      <HorizontalLine />
    </div>
  )
}

const AccountPageAccountDetails = compose<any, any>(
  withWidth(),
  withStyles(themeCreateInjectableStyles(AccountPageAccountDetailsStyles) as any, { withTheme: true }),
)(AccountPageAccountDetailsComponent)


export default AccountPageAccountDetails
